import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { AppRoutesEnum } from '../enums/app-routes.enum';
import { OtpSetupComponent } from './otp-setup/otp-setup.component';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: AppRoutesEnum.Login,
        pathMatch: 'full',
      },
      {
        path: AppRoutesEnum.Login,
        component: LoginComponent,
      },
      {
        path: AppRoutesEnum.Otp,
        component: OtpSetupComponent,
      },
    ],
  },
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ],
})
export class AuthRoutingModule {}
